module.exports = __webpack_public_path__ + "img/FooterSemin.6a89d05b.png";